import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { supabase } from '@/lib/supabase/client';

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const { locale } = useParams();
  const { i18n } = useTranslation();
  const currentLocale = locale || i18n.language || 'fr';

  useEffect(() => {
    // Supabase gère automatiquement le callback via onAuthStateChange
    // On vérifie juste la session et redirige
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();

      if (session) {
        // Utilisateur connecté, rediriger vers le profil
        navigate(`/${currentLocale}/profile`, { replace: true });
      } else {
        // Pas de session, rediriger vers login avec erreur
        navigate(`/${currentLocale}/auth/login`, { replace: true });
      }
    };

    // Attendre un peu pour laisser Supabase traiter le callback
    setTimeout(checkSession, 1000);
  }, [navigate, currentLocale]);

  return (
    <div className="container mx-auto px-4 py-24 text-center">
      <div className="max-w-md mx-auto">
        <div className="animate-pulse mb-4">
          <div className="w-16 h-16 bg-aspexit-green rounded-full mx-auto mb-4"></div>
        </div>
        <p className="text-aspexit-gray">Connexion en cours...</p>
      </div>
    </div>
  );
}
